import get from 'lodash/get';
import set from 'lodash/set';
import ReactDOM from 'react-dom';
import React from 'react';
import {createRoot} from 'react-dom/client'

export default class ReactRender {

    static components = {};

    static registerComponent(name, component){
        if(get(ReactRender.components, name)){
            throw new Error(`Component ${name} already registered`);
        }

        set(ReactRender.components, name, component);
    }

    static render() {
        document.querySelectorAll("[data-react-class]").forEach((element) => {
            let components = this.components;

            let Component = get(components, element.dataset.reactClass);
            let props = JSON.parse(element.dataset.reactProps);

            if (typeof Component === 'undefined' || Component === null) {
                return;
            }

            let JSX = (<Component {...props}/>);

            let root = createRoot(element);

            root.render(JSX);
        });
    }
}
